import TimeList from "@/components/Time/TimeList.vue";
import TimeEdit from "@/components/Time/TimeEdit.vue";
import AssignmentEdit from "@/components/Time/AssignmentEdit.vue";
import TimeFilter from "@/components/Time/TimeFilter.vue";
import TimeHeader from "@/components/Time/TimeHeader.vue";

export default [
    {
        path: 'time',
        name: 'All Time',
        redirect: "/time/list",
        components: {
            page: TimeList,
            header: TimeHeader,
        },
        meta: {
            requiresAuth: false
        },
        children: [
            // DON'T REALLY NEED A FILTER URL ...
            {
                path: "filter",
                name: "Time Filter",
                components: {
                    modal: TimeFilter
                }
            },
            {
                path: "list/:filter?",
                name: "Time List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "new",
                name: "Time New",
                components: {
                    modal: TimeEdit,
                }
            },
            {
                path: "edit/:id",
                name: "Time Edit",
                components: {
                    modal: TimeEdit,
                }
            },
        ]
    },
    {
        path: 'assignment',
        name: 'Assignment',
        redirect: "/time/list",
        components: {
            page: TimeList,
            header: TimeHeader,
        },
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "new",
                name: "Assignment New",
                components: {
                    modal: AssignmentEdit,
                }
            },
            {
                path: "edit/:id",
                name: "Assignment Edit",
                components: {
                    modal: AssignmentEdit,
                }
            },
        ]
    }
];